import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { debounce } from "lodash";

// context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";

// styles
const MountingWrapperStyled = styled.div`
    height: inherit;
`;

// component
const MountingWrapper = ({ children }) => {
    const {
        id,
        hasOpenedBefore,
        setHasOpenedBefore,
        isOpen,
        setIsOpen,
        hideOnScroll
    } = useFormSelectDialog();

    const dialogRef = useRef();

    // onMount
    useEffect(() => {
        const onKeyDown = event => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };
        const onScroll = debounce(() => {
            if (hideOnScroll) {
                setIsOpen(false);
            }
        }, 300);

        window.addEventListener("keydown", onKeyDown);
        document.addEventListener("scroll", onScroll);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("scroll", onScroll);
        };
    }, []);

    // Click Outside
    // https://stackoverflow.com/a/64665817
    useEffect(() => {
        const onClickOutside = e => {
            const withinBoundaries = e
                .composedPath()
                .includes(dialogRef.current);
            if (!withinBoundaries && isOpen) {
                setIsOpen(false);
            }
        };
        window.addEventListener("click", onClickOutside);
        return () => {
            window.removeEventListener("click", onClickOutside);
        };
    }, [dialogRef, isOpen]);

    // Handle Option Focus when dialog opens but only after it has been opened before, not on mount
    useEffect(() => {
        if (isOpen && !hasOpenedBefore) {
            setHasOpenedBefore(true);
        }
    }, [isOpen]);

    return (
        <MountingWrapperStyled id={id} ref={dialogRef}>
            {children}
        </MountingWrapperStyled>
    );
};

export default MountingWrapper;

// prop-types
MountingWrapper.propTypes = {
    children: PropTypes.any
};
